export const OPEN_JOIN_MOTORWAY_PAY_MODAL_HASH = 'openJoinMotorwayModal';
export const OPEN_REQUEST_CALLBACK_MODAL_HASH = 'openModalRequestCallback';
export const MOTORWAY_PAY_HERO_SECTION_ID = 'motorway-pay-find-out-more';

export const MOTORWAY_PAY_UNAUTHORISED_PARAM = 'motorwaypay';

export const KYC_FORM_URL = 'https://help.dealers.motorway.co.uk/hc/en-gb/p/payments-application-form';
